package meineglasfaser.frontend.admin.pages.networks

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import kotlinx.coroutines.flow.update
import meineglasfaser.api.NetworkCategory
import meineglasfaser.api.NetworkCategoryType
import meineglasfaser.api.YaTableOptions
import meineglasfaser.api.routes.AdminRoutes
import meineglasfaser.frontend.admin.components.sections.NetworkCategoryVersion
import meineglasfaser.frontend.admin.components.widgets.YaTable
import meineglasfaser.frontend.admin.components.widgets.named
import meineglasfaser.frontend.admin.components.widgets.sortedAsc
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.Modal
import meineglasfaser.frontend.common.components.widgets.ModalCloseBtn
import meineglasfaser.frontend.common.components.widgets.ModalFooterButtons
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.components.yaform.*
import meineglasfaser.frontend.common.setJsonBody
import meineglasfaser.frontend.common.withAuth
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.*

val NETWORK_CATEGORY_ENTRIES = NetworkCategoryType.entries.map { it to it.name }

@Page
@Composable
fun NetworkCategoriesPage(ctx: PageContext) {
    var version by remember { mutableIntStateOf(0) }
    var showUpdateModal by remember { mutableStateOf<NetworkCategory?>(null) }

    YaTable(
        header = { H1 { Text("Netzkategorien") } },
        idProperty = NetworkCategory::id,
        columns = listOf(
            NetworkCategory::orderPos named "Position",
            NetworkCategory::title named "Titel",
            NetworkCategory::summary named "Kurzbeschreibung",
        ),
        initialOptions = YaTableOptions.DEFAULT.copy(
            orderBy = listOf(
                NetworkCategory::orderPos.sortedAsc(),
            ),
        ),
        fetch = { options ->
            BackendApi.post(AdminRoutes.NetworkCategories()) {
                withAuth()
                setJsonBody(options)
            }
        },
        onViewEntry = { showUpdateModal = it },
        version = version,
    )

    showUpdateModal?.let { category ->
        UpdateNetworkCategoryModal(category) {
            showUpdateModal = null
            version++
            NetworkCategoryVersion.update { it + 1 }
        }
    }
}

@Composable
fun UpdateNetworkCategoryModal(category: NetworkCategory, onHide: () -> Unit) {
    Modal(onHide) {
        YaForm(
            initial = category,
            onSubmitScope = { data ->
                val body = NetworkCategory(
                    id = category.id,
                    type = category.type,
                    orderPos = data.int(NetworkCategory::orderPos),
                    title = data.string(NetworkCategory::title),
                    summary = data.stringOrNull(NetworkCategory::summary) ?: "",
                    details = data.stringOrNull(NetworkCategory::details) ?: "",
                )
                BackendApi.post(AdminRoutes.NetworkCategories.ById(category.id)) {
                    withAuth()
                    setJsonBody(body)
                }.fold(
                    onSuccess = {
                        onHide()
                    },
                    onFailure = { error ->
                        Toasts.display(Toast.error("Fehler beim Speichern der Netzkategorie: ${error.message}"))
                    }
                )
            }
        ) {
            Header {
                ModalCloseBtn(onHide)
                H3 { Text("Netzkategorie bearbeiten") }
            }
            YaFormTextInput(
                prop = NetworkCategory::id,
                label = { Text("ID") },
                type = InputType.Text,
                required = true,
                disabled = true,
            )
            YaFormDropdown(
                prop = NetworkCategory::type,
                label = { Text("Typ") },
                options = NETWORK_CATEGORY_ENTRIES,
                required = true,
                disabled = true,
            )
            YaFormNumberInput(
                prop = NetworkCategory::orderPos,
                label = { Text("Position") },
                min = 0,
                required = true,
            )
            YaFormTextInput(
                prop = NetworkCategory::title,
                label = { Text("Titel") },
                type = InputType.Text,
                required = true,
            )
            YaFormTextArea(
                prop = NetworkCategory::summary,
                label = { Text("Kurzbeschreibung") },
                rows = 3,
                required = false,
            )
            YaFormTextArea(
                prop = NetworkCategory::details,
                label = { Text("Detailbeschreibung") },
                rows = 6,
                required = false,
            )
            ModalFooterButtons(onHide, submitLabel = "Speichern")
        }
    }
}
